(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CampaignCreateController', campaignCreateController)
    .requires
    .push('pikaday');

  campaignCreateController.inject = ['taOptions', 'textAngularManager', 'FoundationApi', 'LangService', 'CampaignService', 'Upload', 'NotificationService', '$location']

  function campaignCreateController (taOptions, textAngularManager, FoundationApi, LangService, CampaignService, Upload, NotificationService, $location) {
    var vm = this;

    taOptions.toolbar = [
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol',
        'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent',
        'html', 'insertLink', 'insertCampaignImageFromS3']
    ];

    LangService
      .getPageLabels({ 'page': 'menu.config.newCampaign' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;

        document.getElementById('btnUploadFile').value = vm.labelsPage.selectFileButton;

        vm.title = vm.labelsPage.titleUpload;
      });

    vm.page = '';
    vm.previousPage = '';
    vm.title = '';
    vm.goToNextPage = goToNextPage;
    vm.goToPreviousPage = goToPreviousPage;
    vm.onChangeChannelType = onChangeChannelType;
    vm.addVariableOnTemplateTextSms = addVariableOnTemplateTextSms;
    vm.addVariableOnTemplateTextEmail = addVariableOnTemplateTextEmail;
    vm.refreshSmsQuantity = refreshSmsQuantity;
    vm.templateText = '';
    vm.fields = '';
    vm.imported_file_id = '';
    vm.channelType = '';
    vm.channel_id = '';
    vm.smsQuantity = 0;
    vm.phoneField = '';
    vm.emailField = '';
    vm.dossieField = '';
    vm.operatorEmailField = '';
    vm.sendType = '';
    vm.sendAtDate = '';
    vm.sendAtHour = '';
    vm.sendAt = '';
    vm.uploadedFile = null;
    vm.delimiter = '';

    vm.smsChannels = [];
    vm.emailChannels = [];

    initPage();

    function initPage () {
      vm.page = 'upload';
      vm.previousPage = '';
    }

    function onChangeChannelType () {
      vm.channel_id = null;
    }

    function goToNextPage () {
      if (validatePage()) {
        switch (vm.page) {
          case 'upload':
            saveUploadedFile();
            loadChannels();

            vm.page = 'channel';
            vm.previousPage = 'upload';
            break;
          case 'channel':
            if (vm.channelType === 'sms') {
              vm.page = 'sms-config';
            } else if (vm.channelType === 'email') {
              vm.page = 'email-config';
            }
            vm.previousPage = 'channel';

            vm.subject = '';
            vm.templateText = '';
            vm.phoneField = '';
            vm.emailField = '';
            vm.dossieField = '';
            vm.operatorEmailField = '';
            vm.sendType = '';
            vm.sendAtDate = '';
            vm.sendAtHour = '';
            break;
          case 'sms-config':
          case 'email-config':
            save();
            break;
          default:
            break;
        }
      }

      loadTitle();
    }

    function goToPreviousPage () {
      switch (vm.page) {
        case 'upload':
          vm.page = 'upload';
          vm.previousPage = '';
          break;
        case 'channel':
          vm.page = 'upload';
          vm.previousPage = '';

          vm.delimiter = '';
          vm.uploadedFile = '';
          break;
        case 'sms-config':
          vm.page = 'channel';
          vm.previousPage = 'upload';

          vm.channel_id = null;
          break;
        case 'email-config':
          vm.page = 'channel';
          vm.previousPage = 'upload';

          vm.channel_id = null;
          break;
        default:
          break;
      }

      loadTitle();
    }

    function loadTitle () {
      switch (vm.page) {
        case 'upload':
          vm.title = vm.labelsPage.titleUpload;
          break;
        case 'channel':
          vm.title = vm.labelsPage.titleChannel;
          break;
        case 'sms-config':
          vm.title = vm.labelsPage.titleSms;
          break;
        case 'email-config':
          vm.title = vm.labelsPage.titleEmail;
          break;
        default:
          vm.title = '';
          break;
      }
    }

    function validatePage () {
      switch (vm.page) {
        case 'upload':

          if (!vm.uploadedFile) {
            NotificationService.errorHandler(vm.uploadedFile, vm.labelsPage.errorNoFile);
            return false;
          }
          if (!vm.delimiter) {
            NotificationService.errorHandler(vm.delimiter, vm.labelsPage.errorNoDelimiter);
            return false;
          }

          break;
        case 'channel':

          if (!vm.channelType) {
            NotificationService.errorHandler(vm.channelType, vm.labelsPage.errorChannelType);
            return false;
          }
          if (!vm.channel_id) {
            NotificationService.errorHandler(vm.channel_id, vm.labelsPage.errorChannelMktzap);
            return false;
          }

          break;
        case 'sms-config':
          if (!vm.templateText) {
            NotificationService.errorHandler(vm.templateText, vm.labelsPage.errorSmsBody);
            return false;
          }
          if (!vm.phoneField) {
            NotificationService.errorHandler(vm.phoneField, vm.labelsPage.errorPhoneField);
            return false;
          }
          if (!vm.sendType) {
            NotificationService.errorHandler(vm.sendAt, vm.labelsPage.errorSendAt);
            return false;
          }
          if (vm.sendType === 'scheduled') {
            if (!vm.sendAtDate) {
              NotificationService.errorHandler(vm.sendAt, vm.labelsPage.errorSendAtDate);
              return false;
            }
            if (!vm.sendAtHour) {
              NotificationService.errorHandler(vm.sendAt, vm.labelsPage.errorSendAtHour);
              return false;
            }
          }
          break;
        case 'email-config':
          if (!vm.templateText) {
            NotificationService.errorHandler(vm.templateText, vm.labelsPage.errorEmailBody);
            return false;
          }
          if (!vm.emailField) {
            NotificationService.errorHandler(vm.emailField, vm.labelsPage.errorEmailField);
            return false;
          }
          if (!vm.sendType) {
            NotificationService.errorHandler(vm.sendAt, vm.labelsPage.errorSendAt);
            return false;
          }
          if (vm.sendType === 'scheduled') {
            if (!vm.sendAtDate) {
              NotificationService.errorHandler(vm.sendAt, vm.labelsPage.errorSendAtDate);
              return false;
            }
            if (!vm.sendAtHour) {
              NotificationService.errorHandler(vm.sendAt, vm.labelsPage.errorSendAtHour);
              return false;
            }
          }
          break;
        default:
          break;
      }

      return true;
    }

    function loadChannels () {
      CampaignService
        .loadChannels()
        .$promise
        .then(function (data) {
          vm.smsChannels = data.sms;
          vm.emailChannels = data.email;
        })
        .catch(function () {
          NotificationService.errorHandler(vm.delimiter, vm.labelsPage.errorChannelLoad);
        });
    }

    function addVariableOnTemplateTextEmail (value) {
      value = '{$' + value + '$}';

      textAngularManager.retrieveEditor('txtAreaTemplateEmail').scope.wrapSelection('insertHTML', value, true);
      textAngularManager.retrieveEditor('txtAreaTemplateEmail').scope.displayElements.text.trigger('focus');
    }

    function addVariableOnTemplateTextSms (value) {
      var field = document.getElementById('txtAreaTemplateSms');
      value = '{$' + value + '$}';

      if (field.selectionStart || field.selectionStart == '0') {
        var startPos = field.selectionStart;
        var endPos = field.selectionEnd;
        field.value = field.value.substring(0, startPos) +
                    value +
                    field.value.substring(endPos, field.value.length);

        if (field.setSelectionRange) {
          var cursorPos = startPos + (value.length);
          field.focus();
          field.setSelectionRange(cursorPos, cursorPos);
        }
      } else {
        field.value += value;
      }
      vm.templateText = field.value;

      refreshSmsQuantity();
    }

    function refreshSmsQuantity () {
      vm.smsQuantity = Math.ceil(document.getElementById('txtAreaTemplateSms').value.length / 160);
    }

    window.upload_file = upload_file;
    vm.file_explorer = file_explorer;

    var fileobj;
    function upload_file (e) {
      e.preventDefault();
      fileobj = e.dataTransfer.files[0];
      validateFileUpload(fileobj);
    }

    function file_explorer () {
      document.getElementById('selectfile').click();
      document.getElementById('selectfile').onchange = function () {
        fileobj = document.getElementById('selectfile').files[0];
        validateFileUpload(fileobj);
      };
    }

    function validateFileUpload (file_obj) {
      vm.uploadedFile = null;
      if (file_obj != undefined) {
        if (file_obj.type !== 'text/csv' && file_obj.type !== 'application/vnd.ms-excel') {
          NotificationService.errorHandler(file_obj, vm.labelsPage.errorFileType);
        } else {
          vm.uploadedFile = file_obj;
          NotificationService.successHandler(file_obj, vm.labelsPage.successFileUpload);
        }
      } else {
        NotificationService.errorHandler(file_obj, vm.labelsPage.errorNoFile);
      }
    }

    function saveUploadedFile () {
      vm.uploadedFile.upload = Upload.upload({
        url: apiUrl + '/campaign-upload',
        file: vm.uploadedFile,
        data: { 'delimiter': vm.delimiter }
      });

      vm.uploadedFile.upload.then(function (response) {
        readFile(response.data);
      }, function (response) {
        if (response.status > 0) { var message = vm.labelsPage.errorReq; }
        if (response) {
          if (response.data) {
            if (response.data.message) { message = response.data.message; }
          }
        }
        FoundationApi.publish('main-notifications', { title: vm.labelsPage.error, content: message, autoclose: '3000', color: 'alert' });
      });
    }

    function readFile (data) {
      CampaignService
        .readFile(data)
        .$promise
        .then(function (data) {
          vm.fields = data.fields;
          vm.imported_file_id = data.imported_file_id;
          vm.uploadedFile.rows = data.rows;
        })
        .catch(function () {

        });
    }

    function save () {
      var obj = {
        'file': {
          'id': vm.imported_file_id,
          'url': vm.uploadedFile.url,
          'name': vm.uploadedFile.name,
          'rows': vm.uploadedFile.rows
        },
        'channel_type': vm.channelType,
        'channel_id': vm.channel_id,
        'fields': {
          'phone': vm.phoneField,
          'email': vm.emailField,
          'dossie': vm.dossieField,
          'operator_email': vm.operatorEmailField
        },
        'data_message': {
          'type': 'text/html',
          'subject': vm.subject,
          'message': vm.templateText
        },
        'send_type': vm.sendType,
        'send_at_date': vm.sendAtDate,
        'send_at_hour': moment(vm.sendAtHour).format('HH:mm'),
        'progress': 0
      };

      CampaignService
        .save(obj)
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler(data, vm.labelsPage.campaignSaved);
          } else {
            NotificationService.errorHandler(data, data.errorMsg);
          }

          $location.path(baseUrl + '/campaign');
        }).catch(function (data) {

        });
    }
  }
})();
